<template>
    <div class="container-fluid w-100" style="overflow: hidden">
    <navbar :title="$t('contract_user_reports.title')"/>
    <div class="search-form px-3 mt-2">
      <span class="px-2">{{ $t('ins_report_details.time') }}</span>
      <div class="row">
        <div class="col-sm-6 p-2">
          <date-time-picker
            v-model:date="fromDate"
            class="routa-input"
            format="dd.MM.yyyy"
          />
        </div>
        <div class="col-sm-6 p-2">
          <date-time-picker
            v-model:date="toDate"
            class="routa-input"
            format="dd.MM.yyyy"
          />
        </div>
      </div>
      <div class="row px-2">
        <!-- Contractor selection -->
          <select
              id="contractorOrder"
              class="form-select form-select-sm"
              v-model="contractor"
              :disabled="contractors.length < 1"
          >
              <option :value="null" disabled>
                  {{ $t('orders.select_contractor') }}
              </option>
              <option
                  v-for="option in contractors"
                  :key="option.id"
                  :value="option.id"
              >
                  {{ option.name }}
              </option>
          </select>
      </div>
      <div class="col-12 d-flex justify-content-end my-2">
        <button
          class="btn btn-primary form-button"
          @click.stop="fetchReport"
        >
          {{ $t('common.search_verb') }}
        </button>
      </div>
    </div>

    <div
      v-if="noResults"
      class="col-sm-12"
    >
      <span slot="noOptions">{{ $t('common.no_results') }}</span>
    </div>
    <div class="col-12 my-2">
      <div
        v-if="results.length > 0"
        class="list-content"
      >
        <div class="col-12 d-flex p-2 px-3 justify-content-end">
          <button
            class="btn btn-outline-success form-button"
            @click.stop="downloadReport"
          >
            {{ $t('trip.download_excel') }}
          </button>
        </div>
        <!-- Persons -->
        <vue3-datatable
              v-if="results.length > 0"
              ref="resultTable"
              :rows="results"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
        >
            <template #time="row">
                {{ toLocalTime(row.value.time) }}
            </template>
        </vue3-datatable>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import {downloadHelper} from "@/components/mixins/DownloadMixin";
import DateTimePicker from "@/components/common/DateTimePicker";
import Navbar from "@/components/utils/Navbar";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {inject} from "vue";

export default {
    name: 'ContractUserReports',
    components: {Navbar, DateTimePicker, Vue3Datatable},
    mixins: [restApi, timeUtils, downloadHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            sortBy: 'last_name',
            sortDesc: false,
            fromDate: new Date().toISOString(),
            toDate: null,
            contractor: null,
            results: [],
            contractors: [],
            loading: false,
            noResults: false,
            fields: [
                {field: 'last_name', title: this.$t('users.last_name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'first_name', title: this.$t('users.first_name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'company_name', title: this.$t('users.company'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract_name', title: this.$t('contracts.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'task_type_name', title: this.$t('observations.order'), sort: true, headerClass: 'routa-table-header'},
                {field: 'time', title: this.$t('ins_report_details.time'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    mounted() {
        this.fetchContractors()
    },
    methods: {
        fetchContractors: function () {
            this.loading = true
            this.restFetch(this.contractorUrl, this.handleContractors)
        },
        handleContractors: function (response) {
            this.loading = false
            if (response && response.data) {
                this.contractors = response.data
            }
        },
        fetchReport: function () {
            this.noResults = false
            this.results = []
            if (this.fromDate) {
                this.loading = true
                this.restFetchParams(this.contractUserUrl, {from: this.fromDate, to: this.toDate, company: this.contractor},
                    this.handleResponse, this.fail)
            }
        },
        handleResponse: function (response) {
            this.loading = false
            if (!response.data || response.data.length < 1) {
                this.noResults = true
            } else {
                this.results = response.data
            }
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('trip_list.err_general'))
        },
        async downloadReport() {
            this.loading = true;
            const { err, ...response } = await this.fetchExcel().catch((err) => ({err}));
            this.loading = false;
            if (err) {
                this.showAlert(this.$t('common.report_generation_failed'))
                return;
            }
            this.downloadFile(response, this.$t('contracts.user_report_file_name'))
        },

        fetchExcel() {
            return this.axios.get(
                this.contractUserReportUrl,
                {
                    params: this.getCommonReportParams({from: this.fromDate, to: this.toDate, company: this.contractor}),
                    responseType: 'arraybuffer'
                }
            )
        },
    }
}
</script>
